import { Box, Button, Container, Grid, Typography } from "@mui/material";
import { AppBarComponent } from "../Components/AppBar";
import { useMemo } from "react";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ExportToCsv } from "export-to-csv"; //or use your library of choice here
import { useLocation } from "react-router-dom";
import { LoaderBox } from "../Components/LoaderBox";

function RptProductos() {
  const { state } = useLocation();
  const { data, header, meses } = state;

  const columns = useMemo(() => [
    {
      accessorKey: "actividad",
      header: "Actividad",
      size: 20,
    },
    {
      accessorKey: "meta",
      header: "Meta Según PEI",
      size: 20,
    },
    {
      accessorKey: "responsable",
      header: "Responsable",
      size: 20,
    },
    {
      accessorKey: "area",
      header: "Área",
      size: 10,
    },
    {
      accessorKey: "departamento",
      header: "Departamento",
      size: 10,
    },
    {
      accessorKey: "municipio",
      header: "Municipio",
      size: 10,
    },
    {
      accessorKey: "upse",
      header: "UPSE",
      size: 20,
    },
    {
      accessorKey: "coorpeacion",
      header: "Cooperación Externa",
      size: 20,
      Cell: ({ renderedCellValue, row }) =>
        row.original.cooperacion ? "Sí" : "No",
    },
    {
      accessorKey: "ejecutado",
      header: "Presupuesto Ejecutado",
      size: 20,
    },
  ]);

  const csvOptions = {
    filename: `ReporteProductos`,
    fieldSeparator: ";",
    quoteStrings: '"',
    decimalSeparator: ".",
    showLabels: true,
    useBom: true,
    useKeysAsHeaders: false,
    headers: columns.map((c) => c.header),
  };

  const csvExporter = new ExportToCsv(csvOptions);

  const handleExportData = () => {
    csvExporter.generateCsv(data);
  };
  return (
    <LoaderBox>
      <Container maxwidth="xl">
        <Grid container>
          <Grid item xs={9}>
            <Typography>
              Reporte por productos:{header}
              <br />
              {meses}
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography>
              Fecha de Generación:
              <br />
              {new Date().toLocaleString() + ""}{" "}
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <MaterialReactTable
        localization={MRT_Localization_ES}
        columns={columns}
        data={data}
        disableColumnMenu={true}
        enableColumnFilters={true}
        enableGlobalFilter={true}
        enableColumnFilterModes={true}
        enableDensityToggle={true}
        enableFullScreenToggle={true}
        enableHiding={false}
        globalFilterFn="contains"
        enableSorting={true}
        initialState={{ density: "comfortable" }}
        renderTopToolbarCustomActions={({ table }) => (
          <Box
            sx={{ display: "flex", gap: "1rem", p: "0.5rem", flexWrap: "wrap" }}
          >
            <Button
              color="primary"
              onClick={handleExportData}
              startIcon={<FileDownloadIcon />}
              variant="contained"
            >
              Exportar
            </Button>
          </Box>
        )}
      />
    </LoaderBox>
  );
}

export { RptProductos };
